import { Injectable } from '@angular/core';
import { GrundstueckRubrikComponentVM } from './grundstueck-rubrik-component-v-m';
import { AppCustomConfigService } from '../../core/services/app-custom-config.service';
import { AppConfigService } from '../../core/services/app-config.service';
import { RubrikConfigEntry } from '../../core/base-api';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import RubrikEnum = RubrikConfigEntry.RubrikEnum;

@Injectable()
export class GrundstueckRubrikService {
  private static getRubrikComponentsVM(rubrik: RubrikEnum, configuredComponents: Array<string>): Array<GrundstueckRubrikComponentVM> {
    let rubriken: Array<GrundstueckRubrikComponentVM> = [];
    if (rubrik) {
      rubrikComponentVMCollection
        .filter((m) => m.parent.toString() === rubrik)
        .forEach((d) => rubriken.push(<GrundstueckRubrikComponentVM>{ ...d }));
    }
    if (configuredComponents) {
      rubriken = rubriken.filter((r) => configuredComponents.find((x) => x === r.element));
      rubriken.sort((a, b) => configuredComponents.indexOf(a.element) - configuredComponents.indexOf(b.element));
    }
    return rubriken;
  }

  public constructor(
    private configService: AppCustomConfigService,
    private appConfigService: AppConfigService
  ) {
    keysToTranslate<string>([
      'grundstueck.rubrik.AlleDaten',
      'grundstueck.rubrik.BeschreibendeDaten',
      'grundstueck.rubrik.Eigentum',
      'grundstueck.rubrik.Dienstbarkeiten',
      'grundstueck.rubrik.Grundlasten',
      'grundstueck.rubrik.Vormerkungen',
      'grundstueck.rubrik.Anmerkungen',
      'grundstueck.rubrik.Grundpfandrechte',
      'grundstueck.rubrik.HaengigeGeschaefte',
      'grundstueck.rubrik.Grundstueckbeschreibung',
      'grundstueck.rubrik.Rangregelung'
    ]);
  }

  public getRubriken(rubrikType: RubrikEnum): Observable<Array<GrundstueckRubrikComponentVM>> {
    return this.configService.getRubrikConfigs().pipe(map((entries) => this.mapToVM(entries, rubrikType)));
  }

  private mapToVM(entries: Array<RubrikConfigEntry>, rubrik: RubrikEnum): Array<GrundstueckRubrikComponentVM> {
    const config: RubrikConfigEntry = this.find(entries, rubrik);
    if (!config || !config.components || config.components.length === 0) {
      // no configuration -> show default behaviour / all components
      return GrundstueckRubrikService.getRubrikComponentsVM(rubrik, undefined);
    }
    // show only configured components
    return GrundstueckRubrikService.getRubrikComponentsVM(rubrik, config.components);
  }

  private find(entries: Array<RubrikConfigEntry>, selected: RubrikEnum): RubrikConfigEntry {
    const selectedItem = entries.filter((a) => a.rubrik === selected);
    if (selectedItem && selectedItem[0]) {
      return selectedItem[0];
    }
    return null;
  }
}

const rubrikComponentVMCollection: Array<GrundstueckRubrikComponentVM> = [
  <GrundstueckRubrikComponentVM>{
    title: 'grundstueck.rubrik.BeschreibendeDaten',
    id: 'beschreibendeDaten',
    isOpen: true,
    isClosable: true,
    element: 'detailGrundstueckBeschreibung',
    parent: 'GB_DETAIL_GRUNDSTUECK'
  },
  <GrundstueckRubrikComponentVM>{
    title: 'grundstueck.rubrik.Eigentum',
    id: 'eigentum',
    isOpen: true,
    isClosable: true,
    element: 'detailGrundstueckEigentum',
    parent: 'GB_DETAIL_GRUNDSTUECK'
  },
  <GrundstueckRubrikComponentVM>{
    title: 'grundstueck.rubrik.Dienstbarkeiten',
    id: 'dienstbarkeiten',
    isOpen: true,
    isClosable: true,
    element: 'detailGrundstueckDienstbarkeiten',
    parent: 'GB_DETAIL_GRUNDSTUECK'
  },
  <GrundstueckRubrikComponentVM>{
    title: 'grundstueck.rubrik.Grundlasten',
    id: 'grundlasten',
    isOpen: true,
    isClosable: true,
    element: 'detailGrundstueckGrundlasten',
    parent: 'GB_DETAIL_GRUNDSTUECK'
  },
  <GrundstueckRubrikComponentVM>{
    title: 'grundstueck.rubrik.Vormerkungen',
    id: 'vormerkungen',
    isOpen: true,
    isClosable: true,
    element: 'detailGrundstueckVormerkungen',
    parent: 'GB_DETAIL_GRUNDSTUECK'
  },
  <GrundstueckRubrikComponentVM>{
    title: 'grundstueck.rubrik.Anmerkungen',
    id: 'anmerkung',
    isOpen: true,
    isClosable: true,
    element: 'detailGrundstueckAnmerkungen',
    parent: 'GB_DETAIL_GRUNDSTUECK'
  },
  <GrundstueckRubrikComponentVM>{
    title: 'grundstueck.rubrik.Grundpfandrechte',
    id: 'grundpfandrechte',
    isOpen: true,
    isClosable: true,
    element: 'detailGrundstueckGrundpfandrechte',
    parent: 'GB_DETAIL_GRUNDSTUECK'
  },
  <GrundstueckRubrikComponentVM>{
    title: 'grundstueck.rubrik.Rangregelung',
    id: 'rangregelungen',
    isOpen: true,
    isClosable: true,
    element: 'detailGrundstueckRangregelungen',
    parent: 'GB_DETAIL_GRUNDSTUECK'
  },
  <GrundstueckRubrikComponentVM>{
    title: 'grundstueck.rubrik.HaengigeGeschaefte',
    id: 'haengigeGeschaefte',
    isOpen: true,
    isClosable: true,
    element: 'detailGrundstueckGeschaefteAuftraege',
    parent: 'GB_DETAIL_GRUNDSTUECK'
  }
];
